// Mock data for AGADIR VIBES — tourist activity concierge
// NOTE: This data is MOCKED for the frontend teaser. It will be replaced by the backend later.

export const CONTACT = {
  phone: "+212 6 68 97 83 63",
  phoneRaw: "212668978363",
  whatsapp: "212668978363",
  email: "agadirvibes1@gmail.com",
  instagram: "https://www.instagram.com/agadir_vibes",
  tiktok: "https://www.tiktok.com/@agadir_vibes_?_r=1&_t=ZN-98PVXPAjSz8",
  city: { fr: "Agadir, Maroc", en: "Agadir, Morocco" },
};

export const CATEGORIES = [
  { id: "all", label: { fr: "Tout", en: "All" } },
  { id: "mer", label: { fr: "Mer & Océan", en: "Sea & Ocean" } },
  { id: "desert", label: { fr: "Désert & Aventure", en: "Desert & Adventure" } },
  { id: "nature", label: { fr: "Nature", en: "Nature" } },
  { id: "culture", label: { fr: "Culture & Soirées", en: "Culture & Evenings" } },
];

export const ACTIVITIES = [
  {
    id: "jet-ski-agadir",
    slug: "jet-ski-agadir",
    category: "mer",
    popular: true,
    image: "https://customer-assets-0z36b82j.emergentagent.net/job_explore-agadir/artifacts/8n0oz6st_IMG_7685.png",
    gallery: [
      "https://customer-assets-0z36b82j.emergentagent.net/job_explore-agadir/artifacts/8n0oz6st_IMG_7685.png",
    ],
    title: { fr: "Jet Ski Agadir", en: "Jet Ski Agadir" },
    location: { fr: "Baie d'Agadir", en: "Agadir Bay" },
    duration: { fr: "15 min – 60 min", en: "15 min – 60 min" },
    short: {
      fr: "Sensations garanties sur l'océan Atlantique à bord de nos jet skis.",
      en: "Guaranteed thrills on the Atlantic Ocean aboard our jet skis.",
    },
    description: {
      fr: "Fendez les vagues de la baie d'Agadir sur un jet ski dernier cri. Une expérience à vivre en solo ou en duo, encadrée par nos moniteurs.",
      en: "Cut through the waves of Agadir Bay on a state-of-the-art jet ski. An experience to enjoy solo or in pairs, supervised by our instructors.",
    },
    priceFromDhs: 350,
    priceFromEur: 35,
    options: [
      { label: { fr: "15 minutes", en: "15 minutes" }, dhs: 350, eur: 35 },
      { label: { fr: "20 minutes", en: "20 minutes" }, dhs: 400, eur: 40 },
      { label: { fr: "30 minutes", en: "30 minutes" }, dhs: 600, eur: 60 },
      { label: { fr: "60 minutes", en: "60 minutes" }, dhs: 1200, eur: 120 },
    ],
    included: [],
    note: {
      fr: "Bouée +350 DHS (35€) jusqu'à 3 personnes.",
      en: "Towable ring +350 DHS (€35) for up to 3 people.",
    },
  },
  {
    id: "jet-ski-tamraght",
    slug: "jet-ski-tamraght",
    category: "mer",
    popular: false,
    image: "https://customer-assets-0z36b82j.emergentagent.net/job_explore-agadir/artifacts/ox03xovi_IMG_7687.png",
    gallery: [
      "https://customer-assets-0z36b82j.emergentagent.net/job_explore-agadir/artifacts/ox03xovi_IMG_7687.png",
    ],
    title: { fr: "Jet Ski à Tamraght", en: "Jet Ski in Tamraght" },
    location: { fr: "Tamraght", en: "Tamraght" },
    duration: { fr: "15 min – 60 min", en: "15 min – 60 min" },
    short: {
      fr: "Le spot surf de Tamraght vu depuis l'eau, plein gaz.",
      en: "The Tamraght surf spot seen from the water, full throttle.",
    },
    description: {
      fr: "Explorez le littoral sauvage de Tamraght en jet ski, l'un des plus beaux spots de la région d'Agadir.",
      en: "Explore the wild coastline of Tamraght by jet ski, one of the most beautiful spots in the Agadir region.",
    },
    priceFromDhs: 300,
    priceFromEur: 30,
    options: [
      { label: { fr: "15 minutes", en: "15 minutes" }, dhs: 300, eur: 30 },
      { label: { fr: "20 minutes", en: "20 minutes" }, dhs: 400, eur: 40 },
      { label: { fr: "30 minutes", en: "30 minutes" }, dhs: 600, eur: 60 },
      { label: { fr: "60 minutes", en: "60 minutes" }, dhs: 1200, eur: 120 },
    ],
    included: [],
    note: null,
  },
  {
    id: "bouee-banane",
    slug: "bouee-banane-tractee",
    category: "mer",
    popular: true,
    image: "https://customer-assets-0z36b82j.emergentagent.net/job_explore-agadir/artifacts/9r5mka6c_IMG_7686.png",
    gallery: [
      "https://customer-assets-0z36b82j.emergentagent.net/job_explore-agadir/artifacts/9r5mka6c_IMG_7686.png",
    ],
    title: { fr: "Bouée & Banane tractée", en: "Towable Ring & Banana Boat" },
    location: { fr: "Baie d'Agadir", en: "Agadir Bay" },
    duration: { fr: "À partir de 15 min", en: "From 15 min" },
    short: {
      fr: "Fous rires garantis en famille ou entre amis sur la banane tractée.",
      en: "Guaranteed laughs with family or friends on the towable banana boat.",
    },
    description: {
      fr: "Accrochez-vous ! Nos bouées et bananes tractées offrent un moment de pur fun sur l'eau, idéal pour les groupes.",
      en: "Hold on tight! Our towable rings and banana boats offer pure fun on the water, ideal for groups.",
    },
    priceFromDhs: 400,
    priceFromEur: 40,
    options: [
      { label: { fr: "3 personnes", en: "3 people" }, dhs: 400, eur: 40 },
      { label: { fr: "4 personnes", en: "4 people" }, dhs: 500, eur: 50 },
      { label: { fr: "5 personnes", en: "5 people" }, dhs: 600, eur: 60 },
    ],
    included: [],
    note: {
      fr: "Maximum 5 personnes pour la banane.",
      en: "Maximum 5 people for the banana boat.",
    },
  },
  {
    id: "balade-bateau",
    slug: "balade-en-bateau",
    category: "mer",
    popular: true,
    image: "https://customer-assets-0z36b82j.emergentagent.net/job_explore-agadir/artifacts/hhce4ysh_IMG_7684.png",
    gallery: [
      "https://customer-assets-0z36b82j.emergentagent.net/job_explore-agadir/artifacts/hhce4ysh_IMG_7684.png",
    ],
    title: { fr: "Balade en bateau", en: "Boat Cruise" },
    location: { fr: "Marina d'Agadir", en: "Agadir Marina" },
    duration: { fr: "30 min à 3h (par tranches de 30 min)", en: "30 min to 3h (30-min increments)" },
    short: {
      fr: "Privatisez un bateau pour 1 à 6 personnes et prenez le large.",
      en: "Privatize a boat for 1 to 6 people and set sail.",
    },
    description: {
      fr: "Une escapade en mer rien que pour vous. Idéal pour un moment romantique, une célébration ou simplement admirer la côte d'Agadir.",
      en: "A sea getaway just for you. Perfect for a romantic moment, a celebration, or simply admiring the Agadir coast.",
    },
    priceFromDhs: 700,
    priceFromEur: 70,
    groupPricing: true,
    maxPeople: 6,
    options: [
      { label: { fr: "30 minutes", en: "30 minutes" }, dhs: 700, eur: 70 },
      { label: { fr: "1 heure", en: "1 hour" }, dhs: 1400, eur: 140 },
      { label: { fr: "1h30", en: "1h30" }, dhs: 2100, eur: 210 },
      { label: { fr: "2 heures", en: "2 hours" }, dhs: 2800, eur: 280 },
      { label: { fr: "2h30", en: "2h30" }, dhs: 3500, eur: 350 },
      { label: { fr: "3 heures", en: "3 hours" }, dhs: 4200, eur: 420 },
    ],
    included: [],
    note: {
      fr: "Prix pour le bateau entier (1 à 6 personnes), par tranches de 30 minutes. En option sur devis : anniversaire, demande en mariage, EVJF…",
      en: "Price for the whole boat (1 to 6 people), in 30-minute increments. Optional on quote: birthday, marriage proposal, hen party…",
    },
  },
  {
    id: "quad-buggy-cross",
    slug: "quad-buggy-cross",
    category: "desert",
    popular: true,
    image: "https://customer-assets-0z36b82j.emergentagent.net/job_explore-agadir/artifacts/90miamm6_IMG_7677.png",
    gallery: [
      "https://customer-assets-0z36b82j.emergentagent.net/job_explore-agadir/artifacts/90miamm6_IMG_7677.png",
    ],
    title: { fr: "Quad, Buggy & Cross", en: "Quad, Buggy & Cross" },
    location: { fr: "Dunes d'Agadir", en: "Agadir Dunes" },
    duration: { fr: "Balade de 2h00", en: "2-hour ride" },
    short: {
      fr: "Domptez les dunes et les pistes en quad, buggy ou moto cross.",
      en: "Tame the dunes and trails on a quad, buggy or cross bike.",
    },
    description: {
      fr: "Une balade de 2 heures à travers les paysages spectaculaires autour d'Agadir. Choisissez votre monture et lancez-vous.",
      en: "A 2-hour ride through the spectacular landscapes around Agadir. Choose your ride and go.",
    },
    priceFromDhs: 350,
    priceFromEur: 35,
    options: [
      { label: { fr: "Quad Auto", en: "Auto Quad" }, dhs: 350, eur: 35 },
      { label: { fr: "Quad Raptor", en: "Raptor Quad" }, dhs: 1000, eur: 100 },
      { label: { fr: "Buggy Can Am", en: "Can Am Buggy" }, dhs: 2000, eur: 200 },
      { label: { fr: "Buggy Standard", en: "Standard Buggy" }, dhs: 800, eur: 80 },
      { label: { fr: "Cross 125 YZ", en: "Cross 125 YZ" }, dhs: 1000, eur: 100 },
    ],
    included: [
      { fr: "L'enregistrement", en: "Registration" },
      { fr: "La mise à disposition du matériel", en: "Equipment provided" },
      { fr: "La balade encadrée", en: "Guided ride" },
      { fr: "Pause thé", en: "Tea break" },
    ],
    note: null,
  },
  {
    id: "entre-dunes-ocean",
    slug: "entre-dunes-ocean",
    category: "desert",
    popular: false,
    image: "https://customer-assets-0z36b82j.emergentagent.net/job_explore-agadir/artifacts/v7j1r9e6_IMG_7675.png",
    gallery: [
      "https://customer-assets-0z36b82j.emergentagent.net/job_explore-agadir/artifacts/v7j1r9e6_IMG_7675.png",
    ],
    title: { fr: "Entre Dunes & Océan", en: "Between Dunes & Ocean" },
    location: { fr: "Côte d'Agadir", en: "Agadir Coast" },
    duration: { fr: "Départ 16h00 – Retour 21h30", en: "Departure 4:00 PM – Return 9:30 PM" },
    short: {
      fr: "Falaises, gorges, dromadaire et sandboard au coucher du soleil.",
      en: "Cliffs, gorges, camel ride and sandboarding at sunset.",
    },
    description: {
      fr: "Une demi-journée d'aventure entre falaises et dunes, ponctuée d'une balade à dos de dromadaire et d'une session de sandboard face à l'océan.",
      en: "A half-day of adventure between cliffs and dunes, with a camel ride and a sandboarding session facing the ocean.",
    },
    priceFromDhs: 450,
    priceFromEur: 45,
    options: [
      { label: { fr: "Excursion (départ 16h00)", en: "Excursion (departs 4:00 PM)" }, dhs: 450, eur: 45 },
    ],
    addons: [
      { id: "transport", label: { fr: "Transport aller/retour (1 à 6 pers.)", en: "Round-trip transport (1–6 people)" }, dhs: 600, eur: 60 },
      { id: "diner", label: { fr: "Dîner au coucher du soleil (1 à 4 pers.)", en: "Sunset dinner (1–4 people)" }, dhs: 450, eur: 45 },
    ],
    included: [
      { fr: "Falaise", en: "Cliff" },
      { fr: "Gorge", en: "Gorge" },
      { fr: "Dromadaire", en: "Camel ride" },
      { fr: "Sandboard", en: "Sandboard" },
      { fr: "Pause thé", en: "Tea break" },
    ],
    note: {
      fr: "Options en supplément (forfait) : transport aller/retour 60€ (1 à 6 pers.), dîner au coucher de soleil 45€ (1 à 4 pers.).",
      en: "Optional extras (flat rate): round-trip transport €60 (1–6 people), sunset dinner €45 (1–4 people).",
    },
  },
  {
    id: "balade-cheval-dromadaire",
    slug: "balade-cheval-dromadaire",
    category: "nature",
    popular: false,
    image: "https://customer-assets-0z36b82j.emergentagent.net/job_explore-agadir/artifacts/6975mc6r_IMG_7683.png",
    gallery: [
      "https://customer-assets-0z36b82j.emergentagent.net/job_explore-agadir/artifacts/6975mc6r_IMG_7683.png",
    ],
    title: { fr: "Balade à cheval ou en dromadaire", en: "Horse or Camel Ride" },
    location: { fr: "Forêt & lac aux flamants roses", en: "Forest & flamingo lake" },
    duration: { fr: "1h30 à 2h00", en: "1h30 to 2h00" },
    short: {
      fr: "Longez la plage et découvrez le lac aux flamants roses.",
      en: "Ride along the beach and discover the flamingo lake.",
    },
    description: {
      fr: "Une balade paisible à cheval ou à dos de dromadaire pour découvrir la forêt et le lac aux flamants roses, entre nature et sérénité.",
      en: "A peaceful ride on horseback or camel to discover the forest and the flamingo lake, between nature and serenity.",
    },
    priceFromDhs: 300,
    priceFromEur: 30,
    options: [
      { label: { fr: "Balade 1h30 – 2h00", en: "Ride 1h30 – 2h00" }, dhs: 300, eur: 30 },
    ],
    included: [],
    note: {
      fr: "Découvrez la forêt et le lac aux flamants roses.",
      en: "Discover the forest and the flamingo lake.",
    },
  },
  {
    id: "grande-fantasia-nocturne",
    slug: "grande-fantasia-nocturne",
    category: "culture",
    popular: true,
    image: "https://customer-assets-0z36b82j.emergentagent.net/job_explore-agadir/artifacts/hsruioe7_IMG_7680.png",
    gallery: [
      "https://customer-assets-0z36b82j.emergentagent.net/job_explore-agadir/artifacts/hsruioe7_IMG_7680.png",
    ],
    title: { fr: "La Grande Fantasia Nocturne", en: "The Grand Nocturnal Fantasia" },
    location: { fr: "Agadir", en: "Agadir" },
    duration: { fr: "Départ 20h00 – Retour 23h30", en: "Departure 8:00 PM – Return 11:30 PM" },
    short: {
      fr: "Dîner marocain, spectacle Tbourida, feu et danses. Les lundis, mercredis et vendredis.",
      en: "Moroccan dinner, Tbourida show, fire and dances. Mondays, Wednesdays and Fridays.",
    },
    description: {
      fr: "Une soirée grandiose sous les étoiles : cavaliers de la Tbourida, cracheurs de feu, acrobates et danseuse orientale, autour d'un festin marocain.",
      en: "A grand evening under the stars: Tbourida riders, fire breathers, acrobats and an oriental dancer, around a Moroccan feast.",
    },
    priceFromDhs: 600,
    priceFromEur: 60,
    childDiscount: 0.5,
    options: [
      { label: { fr: "Soirée complète", en: "Full evening" }, dhs: 600, eur: 60 },
    ],
    included: [
      { fr: "Plats marocains (vegan, sans gluten, allergies pris en compte)", en: "Moroccan dishes (vegan, gluten-free, allergies accommodated)" },
      { fr: "Spectacle Tbourida", en: "Tbourida show" },
      { fr: "Animation musique et danse", en: "Music and dance entertainment" },
      { fr: "Cracheurs de feu et acrobates", en: "Fire breathers and acrobats" },
      { fr: "Danseuse orientale", en: "Oriental dancer" },
      { fr: "Transport aller et retour", en: "Round-trip transport" },
    ],
    note: {
      fr: "Les lundis, mercredis et vendredis. -50% pour les enfants de moins de 12 ans, gratuit pour les moins de 2 ans.",
      en: "Mondays, Wednesdays and Fridays. -50% for children under 12, free for under 2.",
    },
  },
  {
    id: "soiree-traditionnelle",
    slug: "soiree-traditionnelle",
    category: "culture",
    popular: false,
    image: "https://customer-assets-0z36b82j.emergentagent.net/job_explore-agadir/artifacts/sysuxvtb_IMG_7682.png",
    gallery: [
      "https://customer-assets-0z36b82j.emergentagent.net/job_explore-agadir/artifacts/sysuxvtb_IMG_7682.png",
    ],
    title: { fr: "Soirée Traditionnelle", en: "Traditional Evening" },
    location: { fr: "Agadir", en: "Agadir" },
    duration: { fr: "Départ 20h00 – Retour 23h00", en: "Departure 8:00 PM – Return 11:00 PM" },
    short: {
      fr: "Thé, gâteaux, dîner buffet et animations dans une ambiance marocaine.",
      en: "Tea, pastries, buffet dinner and entertainment in a Moroccan atmosphere.",
    },
    description: {
      fr: "Plongez dans la culture marocaine le temps d'une soirée : thé à la menthe, pâtisseries, buffet traditionnel et animations musicales.",
      en: "Dive into Moroccan culture for an evening: mint tea, pastries, traditional buffet and musical entertainment.",
    },
    priceFromDhs: 450,
    priceFromEur: 45,
    childDiscount: 0.5,
    options: [
      { label: { fr: "Soirée complète", en: "Full evening" }, dhs: 450, eur: 45 },
    ],
    included: [
      { fr: "Thé et gâteaux marocains", en: "Moroccan tea and pastries" },
      { fr: "Animation musicale et danse", en: "Music and dance entertainment" },
      { fr: "Dîner buffet marocain", en: "Moroccan buffet dinner" },
      { fr: "Transport aller et retour", en: "Round-trip transport" },
    ],
    note: {
      fr: "-50% pour les enfants de moins de 12 ans.",
      en: "-50% for children under 12.",
    },
  },
  {
    id: "paddle",
    slug: "paddle",
    category: "mer",
    popular: false,
    image: "https://customer-assets-0z36b82j.emergentagent.net/job_explore-agadir/artifacts/6mlba3a6_IMG_7681.png",
    gallery: [
      "https://customer-assets-0z36b82j.emergentagent.net/job_explore-agadir/artifacts/6mlba3a6_IMG_7681.png",
    ],
    title: { fr: "Paddle", en: "Paddleboard" },
    location: { fr: "Baie d'Agadir", en: "Agadir Bay" },
    duration: { fr: "1h à 2h", en: "1h to 2h" },
    short: {
      fr: "Glissez sur l'océan en toute sérénité, à votre rythme.",
      en: "Glide over the ocean in total serenity, at your own pace.",
    },
    description: {
      fr: "Une session de stand-up paddle sur les eaux calmes de la baie d'Agadir. Idéal pour débutants comme confirmés, en solo ou en duo.",
      en: "A stand-up paddle session on the calm waters of Agadir Bay. Perfect for beginners and experts alike, solo or in pairs.",
    },
    priceFromDhs: 150,
    priceFromEur: 15,
    options: [
      { label: { fr: "1 heure", en: "1 hour" }, dhs: 150, eur: 15 },
      { label: { fr: "2 heures", en: "2 hours" }, dhs: 250, eur: 25 },
    ],
    included: [],
    note: null,
  },
  {
    id: "montgolfiere",
    slug: "montgolfiere",
    category: "desert",
    popular: true,
    image: "https://customer-assets-0z36b82j.emergentagent.net/job_explore-agadir/artifacts/6uyxblw6_IMG_7679.png",
    gallery: [
      "https://customer-assets-0z36b82j.emergentagent.net/job_explore-agadir/artifacts/6uyxblw6_IMG_7679.png",
    ],
    title: { fr: "Montgolfière", en: "Hot Air Balloon" },
    location: { fr: "Région d'Agadir", en: "Agadir region" },
    duration: { fr: "40 min de vol", en: "40 min flight" },
    short: {
      fr: "Survolez les paysages marocains au lever du soleil, petit-déjeuner inclus.",
      en: "Fly over the Moroccan landscapes at sunrise, breakfast included.",
    },
    description: {
      fr: "Une expérience inoubliable : 40 minutes de vol en montgolfière au-dessus des paysages spectaculaires de la région, suivies d'un petit-déjeuner sur place.",
      en: "An unforgettable experience: a 40-minute hot air balloon flight over the region's spectacular landscapes, followed by breakfast on site.",
    },
    priceFromDhs: 2100,
    priceFromEur: 210,
    options: [
      { label: { fr: "Vol 40 min", en: "40 min flight" }, dhs: 2100, eur: 210 },
    ],
    included: [
      { fr: "Transport aller et retour", en: "Round-trip transport" },
      { fr: "Petit-déjeuner sur place", en: "Breakfast on site" },
    ],
    note: null,
  },
];

export const TESTIMONIALS = [
  {
    id: 1,
    name: "Camille D.",
    country: { fr: "France", en: "France" },
    rating: 5,
    text: {
      fr: "Une organisation parfaite du début à la fin. Le jet ski dans la baie d'Agadir était inoubliable !",
      en: "Perfect organisation from start to finish. The jet ski in Agadir Bay was unforgettable!",
    },
  },
  {
    id: 2,
    name: "Youssef B.",
    country: { fr: "Maroc", en: "Morocco" },
    rating: 5,
    text: {
      fr: "La Fantasia nocturne est un pur spectacle. Toute la famille a adoré, du repas aux cavaliers.",
      en: "The nocturnal Fantasia is a pure show. The whole family loved it, from the meal to the riders.",
    },
  },
  {
    id: 3,
    name: "Sarah & Liam",
    country: { fr: "Royaume-Uni", en: "United Kingdom" },
    rating: 5,
    text: {
      fr: "Balade à cheval au coucher du soleil et lac aux flamants roses : magique. On reviendra !",
      en: "Sunset horse ride and flamingo lake: magical. We'll be back!",
    },
  },
];
